import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { of, switchMap } from 'rxjs';
import { AuthService } from '@/app/core/auth/auth.service';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);

    // Check the authentication status
    return inject(AuthService)
        .check()
        .pipe(
            switchMap((authenticated) => {
                // Not authenticated → redirect to sign-in
                if (!authenticated) {
                    const redirectURL =
                        state.url === '/sign-out'
                            ? ''
                            : `redirectURL=${encodeURIComponent(state.url)}`;
                    return of(router.parseUrl(`/auth/sign-in?${redirectURL}`));
                }

                // Otherwise allow
                return of(true);
            })
        );
};
